import React, { useEffect, useState } from "react";
import "./scss/App.scss";
import { useQuery } from "./hooks/useQuery";
import { verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";
import { auth } from "./firebase/firebase";

// Assets
import logo from "./assets/HOOBS_Logo.svg";

const PasswordReset: React.FC = () => {
    // Hooks
    const query = useQuery();

    // States
    const [password, setPassword] = useState<string>("");
    const [confirmPassword, setConfirmPassword] = useState<string>("");
    const [error, setError] = useState<string | null>("");
    const [verifiedCode, setVerifiedCode] = useState(false);
    const [passwordResetComplete, setPasswordResetComplete] = useState(false);

    const oobCode = query.get("oobCode");

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value);
    };

    const handleConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmPassword(e.target.value);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        setError(null);

        if (oobCode) {
            if (password.length < 6) {
                setError("Password must be at least 6 characters");
                return;
            }

            if (password !== confirmPassword) {
                setError("Passwords do not match");
                return;
            }

            // change password
            await confirmPasswordReset(auth, oobCode, password);

            console.log("your password has been reset");
            setPasswordResetComplete(true);
        }
    };

    const verifyCode = async () => {
        setError("");
        try {
            if (oobCode) {
                const payload = await verifyPasswordResetCode(auth, oobCode);
                console.log("code from query params:", oobCode);
                console.log("payload", payload);

                if (payload) {
                    setVerifiedCode(true);
                } else {
                    throw new Error("Invalid code.");
                }
            } else {
                window.location.href = "https://hoobs.com";
            }
        } catch (e: any) {
            switch (e.code) {
                case "auth/expired-action-code":
                    console.error("The reset code has expired.");
                    setError("The reset code has expired");
                    break;

                case "auth/invalid-action-code":
                    console.error("The reset code is invalid.");
                    setError("The reset code is invalid");
                    break;

                case "auth/user-disabled":
                    console.error("The user associated with this code has been disabled.");
                    setError("The user associated with this code has been disabled");
                    break;

                case "auth/user-not-found":
                    console.error("No user found for the given reset code.");
                    setError("No user found for the given reset code");
                    break;

                case "auth/network-request-failed":
                    console.error("Network error. Please try again.");
                    setError("Network error. Please try again.");
                    break;

                default:
                    console.error("An unexpected error occurred:", e.message);
                    setError("An unexpected error occured");
                    break;
            }
        }
    };

    useEffect(() => {
        verifyCode();
    }, [oobCode]);

    useEffect(() => {
        if (passwordResetComplete) {
            setTimeout(() => {
                window.location.href = "https://hoobs.com"; // Redirect to home page after 3 seconds
            }, 3000);
        }
    }, [passwordResetComplete]);

    return (
        <div className="container">
            <div className="content">
                <img src={logo} className="logo" />
                {verifiedCode && !passwordResetComplete && (
                    <div className="item">
                        <div className="header">
                            <h1 className="title">Reset Password</h1>
                            <span className="subtitle">Enter a new password and confirm it to reset your password</span>
                        </div>
                        <form onSubmit={handleSubmit} className="form">
                            <div className="form__group">
                                <input type="password" id="password" value={password} onChange={handlePasswordChange} required />
                                <label htmlFor="password">New Password</label>
                            </div>

                            <div className="form__group">
                                <input type="password" id="confirmPassword" value={confirmPassword} onChange={handleConfirmPasswordChange} required />
                                <label htmlFor="confirmPassword">Confirm Password</label>
                            </div>
                            {error && <p className="info__error">{error}</p>}
                            <button type="submit" className="button__primary">
                                Reset Password
                            </button>
                        </form>
                    </div>
                )}
                {passwordResetComplete && <b className="info__success">Password Reset Complete</b>}
            </div>
        </div>
    );
};

export default PasswordReset;
